export function collection_url_cookie(url: string): void {
  // save URL to cookie for 3 hours to be later used in keep shopping link in cart
  const now = new Date();
  now.setTime(now.getTime() + 3 * 3600 * 1000);
  document.cookie = 'collection_url=' + url + '; expires=' + now.toUTCString() + '; path=/';
}

// Single guarded GTM dataLayer push. dataLayer may be absent if GTM
// hasn't loaded, so every call site goes through this guard rather than re-inlining it.
export function pushDataLayer(payload: Record<string, unknown>): void {
  if (!window.dataLayer) return;
  window.dataLayer.push(payload);
}
